module.exports = __webpack_public_path__ + "static/media/duplicate.e663d114.svg";